var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.5C7.36929 12.5 6.25 13.6193 6.25 15C6.25 16.3807 7.36929 17.5 8.75 17.5C10.1307 17.5 11.25 16.3807 11.25 15C11.25 13.6193 10.1307 12.5 8.75 12.5Z",
    fill: "#EB9F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 7.8125C4.78045 7.8125 1.5625 11.0305 1.5625 15C1.5625 18.9695 4.78045 22.1875 8.75 22.1875C11.4757 22.1875 13.8453 20.6704 15.0635 18.4375H19.0625V21.25C19.0625 21.7678 19.4822 22.1875 20 22.1875H24.375C24.8928 22.1875 25.3125 21.7678 25.3125 21.25V18.4375H27.5C28.0178 18.4375 28.4375 18.0178 28.4375 17.5V13.75C28.4375 12.5419 27.4581 11.5625 26.25 11.5625H15.0635C13.8453 9.32964 11.4757 7.8125 8.75 7.8125ZM3.4375 15C3.4375 12.066 5.81599 9.6875 8.75 9.6875C10.927 9.6875 12.8002 10.9971 13.6209 12.8753C13.7701 13.2168 14.1073 13.4375 14.4799 13.4375H26.25C26.4226 13.4375 26.5625 13.5774 26.5625 13.75V16.5625H24.375C23.8572 16.5625 23.4375 16.9822 23.4375 17.5V20.3125H20.9375V17.5C20.9375 16.9822 20.5178 16.5625 20 16.5625H14.4799C14.1073 16.5625 13.7701 16.7832 13.6209 17.1247C12.8002 19.0029 10.927 20.3125 8.75 20.3125C5.81599 20.3125 3.4375 17.934 3.4375 15Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.f8da0dfe4a8b14d0cf92c21aa24aa72a.svg";
export { ForwardRef as ReactComponent };